<template>
  <CommonNoticeCard
    :class="b()"
  >
    <div
      slot="title"
      :class="b('title')"
    >
      <em class="zkicon iconyibiaopan"></em>
      <span :class="b('text')">{{ data.name }}</span>
    </div>
    <div
      slot="content"
      :class="b('tip')"
    >
      <div v-if="data.tip">
        {{ data.tip }}
      </div>
    </div>
    <template #actions>
      <el-button
        type="plaintext2"
        size="mini"
        @click="editSprint"
      >
        {{ $t('notice.dashboard.edit') }}
      </el-button>
    </template>
  </CommonNoticeCard>
</template>

<script>
import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import theme from '@zk/theme/lib/variables.scss';

export default {
  name: 'DashboardConfigNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showPosition: false
    };
  },
  created() {

  },
  methods: {
    async editSprint() {
      this.eventBus.$emit('dashboardConfig', { tab:this.data.tab, list:this.data.list });
    }
  }
};
</script>

<style lang="scss">
 @include b(dashboard-config-notice-card){
     @include e(title){
        .iconyibiaopan{
            margin-right: 8px;
            font-size: 14px;
        }
        font-size: 14px;
        font-weight: 600;
        @include e(text){
            color:var(--font-color-1);
        }
     }
    @include e(tip){
        font-size: 14px;
        font-weight: 400;
         color:var(--font-color-1);
    }
 }
 .dashboardConfigNoticeCard{
    &:before{
      background-color: var(--primary-color);
    }
  .el-notification__closeBtn {
    color: var(--purpleGray-7);
    font-size: 20px;
  }
  .el-notification__content{
    margin-top: 0px;
  }
 }
</style>
